import { VariaveisAmbiente } from 'config';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { PlanosModel } from 'model/api/gestao/plano/planos-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetPlanos() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<PlanosModel>>();

    const getPlanos = useCallback(
        (newPage: number, query?: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Planos?page=${newPage}&${query}`,
                method: 'GET',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getPlanos,
    };
}
